<template>
  <div class="logotoregister">
    <img
      class="inputimg wow animate fadeInUp"
      src="../assets/img/detailimg/register.jpg"
      alt=""
    />
    <div class="recontent">
      <div class="reproduct">{{ $t("login.row1") }}</div>
      <div class="rebiao">
        {{ $t("login.row2") }} (<span
          style="
            color: red;
            margin-left: 5px;
            margin-right: 5px;
            margin-top: 45px;
          "
          >*</span
        >){{ $t("login.row3") }}
      </div>
      <div class="pronews">
        <div class="proself">{{ $t("login.row4") }}</div>
        <div class="proline"></div>
      </div>
      <div class="pleaseclick">
        <span
          style="
            color: red;
            margin-left: 5px;
            margin-right: 5px;
            margin-top: 45px;
          "
          >*</span
        >
        {{ $t("login.row5") }}
      </div>
      <div class="tablethere"></div>
      <!-- 产品信息下面三个input框 -->
      <div class="persoopnals">
        <!-- <div class="styleinfo">{{ $t("login.toubuy") }}</div> -->
        <div class="manyinputs">
          <div class="choosestas">
            <div class="starts" style="color: red">*</div>
            <el-select
              v-model="value"
              :placeholder="kehunews10"
              :class="mobooilep10 ? '' : 'fackending'"
              @blur="mobei10"
              @change="rangehood"
            >
              <el-option
                v-for="item in optddions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="choosestas">
            <div class="starts" style="color: #ff0000">*</div>
            <el-select
              v-model="valuetwo"
              :placeholder="kehunews11"
              :class="mobooilep11 ? '' : 'fackending'"
              @blur="mobei11"
              @focus="thirsty"
            >
              <el-option
                v-for="item in optionstwo"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="choosestas">
            <div class="starts" style="color: #ff0000">*</div>
            <div class="inputforfather">
              <el-input
                :placeholder="kehunews12"
                v-model="new10"
                :class="mobooilep12 ? '' : 'fackending'"
                class="input-new0"
                @blur="mobei12"
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="manyckecd">
        <div class="leftwidhh">
          <span
            style="
              color: red;
              margin-left: 5px;
              margin-right: 5px;
              margin-top: 45px;
            "
            >*</span
          ><span :class="mmorekuang ? '' : 'fackending'" class="wherekonw">{{
            $t("login.row6")
          }}</span>
        </div>
        <div class="cheself">
          <el-checkbox-group
            v-model="checkedCities"
            @blur="bye88"
            @change="monrchoos"
          >
            <el-checkbox
              v-for="city in citdddies"
              :label="city"
              :key="city.index"
              >{{ city.label }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
      <div class="manyckecd">
        <div class="leftwidhh">
          <span
            style="
              color: red;
              margin-left: 5px;
              margin-right: 5px;
              margin-top: 45px;
            "
            >*</span
          ><span :class="fyoumoth ? '' : 'fackending'" class="wherekonw">{{
            $t("login.row7")
          }}</span>
        </div>
        <div class="cheself">
          <el-checkbox-group
            v-model="checkyyyedCities"
            @blur="bye99"
            @change="monrooochoos"
          >
            <el-checkbox
              v-for="city in onting"
              :label="city"
              :key="city.index"
              >{{ city.label }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
      <div class="pronews">
        <div class="proself">{{ $t("login.row8") }}</div>
        <div class="proline prolinetwo"></div>
      </div>
      <div class="persoopnals">
        <!-- <div class="styleinfo">{{ $t("login.toubuy") }}</div> -->
        <div class="manyinputs">
          <div class="choosestas">
            <div class="starts" style="color: red">*</div>
            <el-select
              v-model="doorname"
              :placeholder="Storename"
              :class="mobooilep13 ? '' : 'fackending'"
              @blur="mobei13"
              @change="randoor"
            >
              <el-option
                v-for="item in manrednn"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>

          <div class="choosestas">
            <!-- <div class="starts" style="color: #ff0000">*</div> -->
            <div class="inputforfather">
              <el-input
                :placeholder="fatiapla"
                v-model="fanumeparl"
                class="input-new0"
              >
              </el-input>
            </div>
          </div>
          <!-- <div class="choosestas">
            <div class="starts" style="color: #ff0000">*</div>
            <el-select
              v-model="valuetwo"
              :placeholder="kehunews11"
              :class="mobooilep11 ? '' : 'fackending'"
              @blur="mobei11"
              @focus="thirsty"
            >
              <el-option
                v-for="item in optionstwo"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div> -->
          <div class="choosestas">
            <div class="starts" style="color: #ff0000">*</div>
            <div class="block">
              <el-date-picker
                v-model="parktime"
                type="date"
                :placeholder="kehunews15"
                :clearable="false"
                :class="mobooilep15 ? '' : 'fackending'"
                @blur="mobei15"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="pronews ernejjke">
        <div class="proself">{{ $t("login.row9") }}</div>
        <div class="proline prolinetwo"></div>
      </div>
      <!-- 个人信息***************************************************************************** -->
      <div class="persoopnals" style="margin-top: 30px">
        <!-- <div class="styleinfo">{{ $t("login.toubuy") }}</div> -->
        <div class="manyinputs">
          <div class="choosestas">
            <div class="starts" style="color: red">*</div>
            <el-select
              v-model="addcame"
              :placeholder="noleing1"
              :class="person1 ? '' : 'fackending'"
              @blur="missson1"
            >
              <el-option
                v-for="item in chenhu"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </div>
          <div class="choosestas">
            <div class="starts" style="color: #ff0000">*</div>
            <div class="inputforfather">
              <el-input
                :placeholder="call7"
                v-model="kehname"
                :class="person2 ? '' : 'fackending'"
                class="input-new0"
                @blur="missson2"
              >
              </el-input>
            </div>
          </div>
          <div class="choosestas">
            <!-- <div class="starts" style="color: #ff0000">*</div> -->
            <div class="inputforfather">
              <el-input
                :placeholder="call8"
                v-model="diandizi"
                class="input-new0"
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <!-- 省市区***************************************************************************** -->
      <div class="persoopnals">
        <!-- <div class="styleinfo">{{ $t("login.toubuy") }}</div> -->
        <div class="manyinputs" style="margin-top: 10px">
          <div class="choosestas">
            <div class="starts" style="color: red">*</div>
            <el-select
              v-model="shengthing"
              :placeholder="noleing9"
              :class="teadd1 ? '' : 'fackending'"
              @blur="misshi1"
              @change="randing1"
            >
              <el-option
                v-for="item in thirdlist"
                :key="item.value"
                :label="item.province_idy"
                :value="item.province_idy"
              >
              </el-option>
            </el-select>
          </div>
          <div class="choosestas">
            <div class="starts" style="color: red">*</div>
            <el-select
              v-model="shithing"
              :placeholder="noleing10"
              :class="teadd2 ? '' : 'fackending'"
              @blur="misshi2"
              @change="randing2"
              @focus="needing1"
            >
              <el-option
                v-for="item in cinglist"
                :key="item.value"
                :label="item.city_idy"
                :value="item.city_idy"
              >
              </el-option>
            </el-select>
          </div>
          <div class="choosestas">
            <div class="starts" style="color: red">*</div>
            <el-select
              v-model="quthing"
              :placeholder="noleing11"
              :class="teadd3 ? '' : 'fackending'"
              @blur="misshi3"
              @focus="needing2"
            >
              <el-option
                v-for="item in qulist"
                :key="item.value"
                :label="item.districts_idy"
                :value="item.districts_idy"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <!-- 邮政编码 **************************************************************-->
      <div class="persoopnals">
        <!-- <div class="styleinfo">{{ $t("login.toubuy") }}</div> -->
        <div class="manyinputs" style="margin-top: 10px">
          <div class="choosestas">
            <div class="starts" style="color: #ff0000">*</div>
            <div class="inputforfather">
              <el-input
                :placeholder="call12"
                v-model="phing1"
                :class="youzheng ? '' : 'fackending'"
                class="input-new0"
                @blur="hbrthing"
              >
              </el-input>
            </div>
          </div>
          <div class="choosestas dfsiking">
            <!-- <div class="starts" style="color: #ff0000">*</div> -->
            <div class="inputforfather">
              <el-input
                :placeholder="call13"
                v-model="phing2"
                class="input-new0"
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>
      <!-- 地址 **************************************************************-->
      <div class="textfather">
        <div class="lasstart" style="color: #ff0000">*</div>
        <textarea
          name=""
          id=""
          cols="30"
          rows="10"
          :placeholder="call14"
          v-model="lastdee"
          :class="shiqure ? '' : 'fackending'"
          @blur="losetect"
        ></textarea>
      </div>

      <!-- bottom **************************************************************-->
      <div class="pronews ernejjke">
        <div class="proself" style="font-size: 22px">
          {{ $t("login.row10") }}
        </div>
        <div class="proline prolinetwo"></div>
      </div>
      <div class="normaly">
        {{ $t("login.row11") }}
      </div>
      <div class="normaly">
        {{ $t("login.row12") }}
      </div>
      <div class="normaly">
        {{ $t("login.row13") }}
      </div>
      <div class="normaly">
        {{ $t("login.row14") }}
      </div>
      <div class="normaly">
        {{ $t("login.row15") }}
      </div>
      <div class="pronews ernejjke" style="margin-top: 50px">
        <div class="proself">{{ $t("login.row16") }}</div>
        <div class="proline prolinetwo namuse"></div>
      </div>
      <div class="normaly">
        {{ $t("login.row17") }}
      </div>
      <div class="normaly">
        {{ $t("login.row18") }}
      </div>
      <div class="normaly">{{ $t("login.row19") }}</div>
      <div class="normaly">
        {{ $t("login.row20") }}
      </div>
      <div class="normaly">
        {{ $t("login.row21") }}
      </div>
      <div class="normaly">
        {{ $t("login.row22") }}
      </div>
      <div class="normaly">
        {{ $t("login.row23") }}
      </div>
      <div class="niunku">
        <div class="bothhout">
          <div class="bottomgry">
            <el-checkbox v-model="beiyouh"></el-checkbox>
          </div>
          <div class="alerady">
            {{ $t("login.agree1") }}
          </div>
        </div>
        <div class="arggmaj">
          {{ $t("login.agree2") }}
        </div>
      </div>
      <div class="blackborr" @click="tosubmit">{{ $t("login.restnow") }}</div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import {
  guarantee,
  getseries,
  getIdshops,
  getIdprovince,
  getIdcity,
  getIddistricts,
  guaranteeforid,
} from "../request/api";
// const cityOptions = [
//   "广告语促销",
//   "朋友推荐",
//   "方太脸书/网站",
//   "展览",
//   "经销商推荐",
// ];
const cityOrrrptions = ["设计", "质量", "功能", "价格"];
export default {
  data() {
    return {
      beiyouh: "",
      mobooilep10: true,
      january: "",
      valuetwo: "",
      mobooilep11: true,
      optionstwo: [],
      value: "",
      valuetwo: "",
      new10: "",
      mobooilep12: true,
      checkedCities: [],
      checkyyyedCities: [],
      // cities: [],
      // onting: [],
      doorname: "",
      mobooilep13: true,
      manrednn: [],
      fanumeparl: "",
      mobooilep15: true,
      parktime: "",
      person1: true,
      addcame: "",
      kehname: "",
      person2: true,
      diandizi: "",
      shengthing: "",
      shithing: "",
      quthing: "",
      teadd1: true,
      teadd2: true,
      teadd3: true,
      thirdlist: [],
      shengid: "",
      cityid: "",
      cinglist: [],
      qulist: [],
      youzheng: true,
      phing1: "",
      phing2: "",
      lastdee: "",
      shiqure: true,
      mmorekuang: true,
      fyoumoth: true,
      oncehni: [],
      twochej: [],
      sdguanghu: "",
      ghunghue: [],
      defhyu: "",
    };
  },
  created() {
    this.$bus.$emit("registid", 1);

    setTimeout(() => {
      this.$route.meta.title = this.$t("login.querythere20");
      this.$router.replace({
        query: {
          temp: Date.now(), //必有
        },
      });
    }, 10);
    this.$bus.$on("add", (message, b, d) => {
      // this.outgetseries(message, b);
      this.outreccookbooklist(message, b);
      this.$route.meta.title = this.$t("login.querythere20");
      this.$router.replace({
        query: {
          temp: Date.now(), //必有
        },
      });
    });
    this.outgetitpo();

    if (sessionStorage.getItem("newlangusge") == null) {
      this.outreccookbooklist("id", "id", "d");
    } else {
      this.outreccookbooklist("id", sessionStorage.getItem("newlangusge"), "d");
    }
  },

  mounted() {
    if (document.documentElement.scrollTop > 0) {
      document.documentElement.scrollTop = 0;
    }
    // document.documentElement.scrollTop = 0;
    // window.addEventListener("scroll", '0');
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      const wow = new WOW({
        offset: 0,
        // mobile: true,
        live: true,
      });
      wow.init();
    });
  },
  methods: {
    otusjj(a) {
      guaranteeforid({
        lang: a,
        cate_name: this.value,
        code: this.valuetwo,
        serial_number: this.new10,
        source: this.sdguanghu,
        reason: this.defhyu,
        shops: this.doorname,
        invoice_number: this.fanumeparl,
        purchase_date: this.parktime,
        call: this.addcame,
        name: this.kehname,
        email: this.diandizi,
        province: this.shengthing,
        city: this.shithing,
        districts: this.quthing,
        zip_code: this.phing1,
        phone: this.phing2,
        tel: this.phing2,
        address: this.lastdee,
      }).then((res) => {
        this.$message({
          message: this.$t("login.sucssfil"),

          type: "success",
          offset: 90,
        });
      });
    },
    outreccookbooklist(a, b, c) {
      getIdprovince({
        lang: b,
        country: a,
      }).then((res) => {
        console.log(res);
        this.thirdlist = res.data;
      });
    },
    outcoity(a, b, c) {
      getIdcity({
        lang: b,
        country: a,
        province: this.shengid,
      }).then((res) => {
        console.log(res);
        this.cinglist = res.data;
      });
    },
    outqubie(a, b, c) {
      getIddistricts({
        lang: b,
        country: a,
        city: this.cityid,
      }).then((res) => {
        console.log(res);
        this.qulist = res.data;
      });
    },
    mobei15() {
      this.mobooilep15 = true;
    },
    outgetitpo() {
      getIdshops({
        country: "id",
      }).then((res) => {
        console.log(res);
        this.manrednn = res.data;
      });
    },
    monrchoos(e) {
      console.log(e);
      console.log(this.checkedCities);
      this.checkedCities.forEach((e) => {
        console.log(e);
        this.oncehni.push(e.label);
      });
      Array.prototype.distinct = function () {
        var arr = this,
          result = [],
          i,
          j,
          len = arr.length;
        for (i = 0; i < len; i++) {
          for (j = i + 1; j < len; j++) {
            if (arr[i] === arr[j]) {
              j = ++i;
            }
          }
          result.push(arr[i]);
        }
        return result;
      };
      var arra = this.oncehni;
      arra.distinct();

      console.log(arra.distinct().join(","));
      this.sdguanghu = arra.distinct().join(",");
      console.log(this.sdguanghu);

      if (this.checkedCities.length > 0) {
        this.mmorekuang = true;
      }
    },
    monrooochoos(e) {
      console.log(e);
      console.log(this.checkyyyedCities);

      this.checkyyyedCities.forEach((e) => {
        console.log(e);
        this.ghunghue.push(e.label);
      });
      Array.prototype.distinct = function () {
        var arr = this,
          result = [],
          i,
          j,
          len = arr.length;
        for (i = 0; i < len; i++) {
          for (j = i + 1; j < len; j++) {
            if (arr[i] === arr[j]) {
              j = ++i;
            }
          }
          result.push(arr[i]);
        }
        return result;
      };
      var eee = this.ghunghue;
      eee.distinct();

      console.log(eee.distinct().join(","));
      this.defhyu = eee.distinct().join(",");
      console.log(this.defhyu);

      if (this.checkyyyedCities.length > 0) {
        this.fyoumoth = true;
      }
    },
    mobei11() {
      this.mobooilep11 = true;
    },
    mobei10() {
      this.mobooilep10 = true;
    },
    mobei12() {
      this.mobooilep12 = true;
    },
    bye88() {
      this.mmorekuang = true;
    },
    bye99() {
      this.fyoumoth = true;
    },
    missson1() {
      this.person1 = true;
    },
    losetect() {
      this.shiqure = true;
    },
    missson2() {
      this.person2 = true;
    },
    mobei13() {
      this.mobooilep13 = true;
    },
    misshi1() {
      this.teadd1 = true;
    },
    misshi2() {
      this.teadd2 = true;
    },
    hbrthing() {
      this.youzheng = true;
    },
    misshi3() {
      this.teadd3 = true;
    },
    randing1(e) {
      console.log(e);
      this.shengid = e;
      this.shithing = "";
      this.quthing = "";
    },
    randing2(e) {
      console.log(e);
      this.cityid = e;
      this.quthing = "";
    },
    needing1() {
      if (sessionStorage.getItem("newlangusge") == null) {
        this.outcoity("id", "id", "d");
      } else {
        this.outcoity("id", sessionStorage.getItem("newlangusge"), "d");
      }
    },
    needing2() {
      if (sessionStorage.getItem("newlangusge") == null) {
        this.outqubie("id", "id", "d");
      } else {
        this.outqubie("id", sessionStorage.getItem("newlangusge"), "d");
      }
    },

    rangehood(e) {
      console.log(e);
      this.january = e;
      this.valuetwo = "";
    },
    randoor() {
      console.log(this.doorname);
    },
    thirsty() {
      console.log(111111111111);
      if (sessionStorage.getItem("newlangusge") == null) {
        this.outgetseries("id", "id", "d");
      } else {
        this.outgetseries("id", sessionStorage.getItem("newlangusge"));
      }
    },
    outgetseries(a, b, c) {
      getseries({
        lang: b,
        country: a,
        cate: this.january,
      }).then((res) => {
        console.log(res);
        this.optionstwo = res.data;
      });
    },
    tosubmit() {
      console.log(112222222222222);
      if (this.value == "") {
        this.mobooilep10 = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.valuetwo == "") {
        this.mobooilep11 = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.new10 == "") {
        this.mobooilep12 = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.checkedCities == "") {
        this.mmorekuang = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.checkyyyedCities == "") {
        this.fyoumoth = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.doorname == "") {
        this.mobooilep13 = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.parktime == "") {
        this.mobooilep15 = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.addcame == "") {
        this.person1 = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.kehname == "") {
        this.person2 = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.shengthing == "") {
        this.teadd1 = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.shithing == "") {
        this.teadd2 = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.quthing == "") {
        this.teadd3 = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.phing1 == "") {
        this.youzheng = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else if (this.lastdee == "") {
        this.shiqure = false;
        this.$message({
          message: this.$t("login.borderred"),
          type: "error",
          offset: 90,
        });
      } else {
        if (sessionStorage.getItem("newlangusge") == null) {
          this.otusjj("id");
        } else {
          this.otusjj(sessionStorage.getItem("newlangusge"));
        }
      }
    },
  },
  computed: {
    kehunews15() {
      return this.$t("login.kehunews15");
    },
    fatiapla() {
      return this.$t("login.Nomorfaktur");
    },
    kehunews12() {
      return this.$t("login.kehunews12");
    },
    call7() {
      return this.$t("login.call7");
    },
    call12() {
      return this.$t("login.call12");
    },
    call13() {
      return this.$t("login.call13");
    },
    call14() {
      return this.$t("login.call14");
    },
    call8() {
      return this.$t("login.call8");
    },
    kehunews10() {
      return this.$t("login.kehunews10");
    },
    noleing1() {
      return this.$t("login.callbig");
    },
    noleing9() {
      return this.$t("login.call9");
    },
    noleing10() {
      return this.$t("login.call10");
    },
    noleing11() {
      return this.$t("login.call11");
    },
    Storename() {
      return this.$t("login.Storename");
    },
    kehunews11() {
      return this.$t("login.kehunews11");
    },
    citdddies: function () {
      return [
        { label: this.$t("login.cherdkk1") },
        { label: this.$t("login.cherdkk2") },
        { label: this.$t("login.cherdkk3") },
        { label: this.$t("login.cherdkk4") },
        { label: this.$t("login.cherdkk5") },
      ];
    },
    onting: function () {
      return [
        { label: this.$t("login.cherdkk6") },
        { label: this.$t("login.cherdkk7") },
        { label: this.$t("login.cherdkk8") },
        { label: this.$t("login.cherdkk9") },
      ];
    },
    optddions: function () {
      return [
        {
          value: "1",
          label: this.$t("login.rangehoods"),
        },
        {
          value: "2",
          label: this.$t("login.hobs"),
        },
        {
          value: "3",
          label: this.$t("login.lectricovens"),
        },
        {
          value: "4",
          label: this.$t("login.steamovens"),
        },
        {
          value: "5",
          label: this.$t("login.micovens"),
        },
        {
          value: "6",
          label: this.$t("login.dishwasher"),
        },
      ];
    },
    chenhu: function () {
      return [
        { label: this.$t("login.call1") },
        { label: this.$t("login.call2") },
        { label: this.$t("login.call3") },
        { label: this.$t("login.call4") },
        { label: this.$t("login.call5") },
        { label: this.$t("login.call6") },
      ];
    },
  },
  beforeDestroy() {
    this.$bus.$emit("registid", 2);
  },
  destroyed() {},
};
</script>
<style lang="less" scoped>
.logotoregister {
  display: flex;
  flex-direction: column;
  .inputimg {
    width: 100%;
    // height: 500px;
  }
}
.recontent {
  width: 1000px;
  margin: 0 auto;
  .reproduct {
    margin-top: 60px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #747474;
    line-height: 36px;
  }
  .rebiao {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #747474;
    line-height: 36px;
  }
  .pronews {
    display: flex;
    margin-top: 60px;
    align-items: center;
    justify-content: space-between;
    .proself {
      font-size: 26px;
      font-family: Adobe Heiti Std;
      font-weight: normal;
      color: #000000;
    }
    .proline {
      width: 731px;
      height: 1px;
      background: #404040;
      // margin-left: 162px;
    }
    .prolinetwo {
      width: 731px;
      height: 1px;
      background: #404040;
      // margin-left: 162px;
    }
    .namuse {
      width: 731px;
    }
  }
  .ernejjke {
    margin-top: 20px;
  }
  .pleaseclick {
    margin-top: 30px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;

    color: #747474;
  }
}
.persoopnals {
  display: flex;
  flex-direction: column;
  .styleinfo {
    margin-top: 20px;
    font-size: 18px;
    // font-family: Arial;
    font-weight: bold;
    color: #000000;
  }
  .manyinputs {
    margin-top: 40px;

    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .choosestas {
      position: relative;
      .starts {
        position: absolute;
        top: 14px;
        left: 6px;
        z-index: 2;
      }
    }
    /deep/ .el-input {
      width: 320px;
      // height: 60px;
      // margin-bottom: 20px;
      // margin-bottom: 24px;
    }
    /deep/ .el-input__inner {
      background: #f2f2f2;
      border: 0px solid #e6e6e6;
      border-radius: 5px;
      height: 38px;
    }
    /deep/ .el-input__inner::placeholder {
      color: #c7c7c7;
    }

    /deep/ .el-input__suffix {
      top: 1px;
      right: 8px;
    }
    /deep/ .el-select__caret {
      -webkit-transform: none;
      transform: none;
    }

    /deep/ .el-icon-arrow-up:before {
      content: "\e790";
    }
    // /deep/.el-input__icon .el-icon-date {
    //   top: 2px;
    // }
    /deep/ .el-select {
      margin-bottom: 24px;
    }

    .addinputes {
      width: 1199px;
      height: 40px;
      border: 1px dashed #e6e6e6;
      border-radius: 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        width: 10px;
        height: 10px;
      }
    }
    .chooseall {
      // margin-top: 20px;
    }
    .deawidinput {
      margin-top: 20px;
      /deep/ .el-input {
        width: 660px !important;
        height: 40px;
        margin-bottom: 20px;
      }
      /deep/ .el-input__inner {
        background: #f5f5f5;
        border: 1px solid #e6e6e6;
        border-radius: 3px;
      }

      /deep/ .el-input__suffix {
        top: 0px;
        right: 8px;
      }
    }
    .deawidinputtwo {
      margin-top: 0px;
      width: 660px;
      /deep/ .el-input {
        height: 60px;
        margin-bottom: 20px;
      }
      /deep/ .el-input__inner {
        background: #f5f5f5;
        border: 0px solid #e6e6e6;
        border-radius: 3px;
      }

      /deep/ .el-input__suffix {
        top: -8px;
        right: 15px;
      }
    }

    /deep/ .el-input--prefix .el-input__inner {
      padding-left: 15px;
    }
    .REGISTERNOW {
      font-size: 12px;
      // font-family: Arial;
      font-weight: bold;
      color: #fff;
      width: 180px;
      height: 48px;
      background: #000000;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      margin-top: 50px;
      margin-bottom: 120px;
      cursor: pointer;
    }
    .REGISTERNOW:hover {
      // border: 1px solid #9e1d22;
      background-size: 14px 10px;
      background-color: #9e1d22;
    }
  }
}
.fackending {
  border: 1px solid red !important;
}
.manyckecd {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #9d2736;
  }
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #9d2736;
    border-color: #9d2736;
    border-radius: 50%;
  }
  /deep/ .el-checkbox__inner {
    border-radius: 200px !important;
  }
  .wherekonw {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #898989;
  }
  .leftwidhh {
    // width: 1200px;
  }
  .cheself {
    // width: 300px;
  }
}
.block {
  /deep/ .el-input__prefix,
  .el-input__suffix {
    position: absolute;
    top: 1px;
    right: -275px;
  }
}
.normaly {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 30px;
  margin-top: 20px;
}
.niunku {
  margin-top: 50px;
  width: 1000px;
  // height: 200px;
  background: #f2f2f2;
  overflow: hidden;
  margin-bottom: 49px;

  .bothhout {
    display: flex;
    margin-top: 36px;
    margin-left: 20px;
    .alerady {
      // width: 456px;
      // height: 22px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      // text-decoration: underline;
      color: #ff0000;
      margin-left: 10px;
    }
    .bottomgry {
      /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #9d2736;
      }
      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #9d2736;
        border-color: #9d2736;
        border-radius: 50%;
      }
      /deep/ .el-checkbox__inner {
        border-radius: 200px !important;
      }
    }
  }
  .arggmaj {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 27px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    padding-bottom: 20px;
  }
}
.blackborr {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 240px;
  height: 60px;
  background: #000000;
  border-radius: 10px;
  color: white;
  margin-bottom: 168px;
}
.dfsiking {
  /deep/ .el-input {
    width: 660px !important;
  }
}
textarea {
  width: 1000px;
  height: 120px;
  background: #f5f5f5;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  resize: none;
  outline: none;
  border: none;
  margin-top: 30px;
  text-indent: 1em;
  padding-top: 10px;
  margin-bottom: 50px;
}
textarea::-webkit-input-placeholder {
  color: #c7c7c7;
  font-size: 16px;
}
.textfather {
  position: relative;
  .lasstart {
    position: absolute;
    top: 47px;
    left: 7px;
  }
}
</style>